/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum FolderAccessType {
    PUBLIC = 'Public',
    PRIVATE = 'Private',
}
